import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { ContractorBaseAuction } from '../../home/models/contractor-base-auction';
import { DistributorType } from '../../home/models/distributor-type';
import { OtherKpFilter } from '../models/other-kp-filter';
import { LoggingService } from '../../../services/logging.service';


@Injectable()
export class BusOtherKpFilterService {
  private messageFilter = new BehaviorSubject<OtherKpFilter>(new OtherKpFilter());
  private messageOtherKpNumber = new BehaviorSubject<string>('');
  private messageClearModalFilter = new BehaviorSubject<string>('');
  private messageClearSearchModalFields = new BehaviorSubject<string>('');
  private messageContractBaseOtherKp = new BehaviorSubject<ContractorBaseAuction>(new ContractorBaseAuction());

  private currentStateOtherKpFilter = new OtherKpFilter();

  currentFilter$ = this.messageFilter.asObservable();
  currentOtherKpNumber$ = this.messageOtherKpNumber.asObservable();
  currentClearModalFilter$ = this.messageClearModalFilter.asObservable();
  currentClearSearchModalFields$ = this.messageClearSearchModalFields.asObservable();
  currentContractBaseOtherKp$ = this.messageContractBaseOtherKp.asObservable();

  currentDistributorType = new DistributorType()

  constructor(private loggingService: LoggingService) { }

  changeFilter(filter: OtherKpFilter, isClear = false) {
    const _xid = this.loggingService.generateUUID();
    
    try {
      this.loggingService.logStart(_xid, 'App.Services.BusOtherKpFilterService.changeFilter', null, 'Change filter started');
      
      if (!isClear) {
        Object.keys(filter).forEach(key => {
          if (filter[key] != null) {
            this.currentStateOtherKpFilter[key] = filter[key];
          }
        });
      } else {
        Object.keys(filter).forEach(key => {
          if (filter[key] == null || filter[key].length === 0) {
            this.currentStateOtherKpFilter[key] = null;
          }
        });
      }

      this.messageFilter.next(this.currentStateOtherKpFilter);
      
      this.loggingService.logFinish(_xid, 'App.Services.BusOtherKpFilterService.changeFilter', null, 'Change filter completed');
    } catch (_error) {
      this.loggingService.logError(_xid, 'App.Services.BusOtherKpFilterService.changeFilter', _error, null, 'Change filter failed');
      throw _error;
    }
  }

  changeOtherKpNumber(otherKpNumber: string) {
    const _xid = this.loggingService.generateUUID();
    
    try {
      this.loggingService.logStart(_xid, 'App.Services.BusOtherKpFilterService.changeOtherKpNumber', null, 'Change other KP number started');
      
      this.messageOtherKpNumber.next(otherKpNumber);
      
      this.loggingService.logFinish(_xid, 'App.Services.BusOtherKpFilterService.changeOtherKpNumber', null, 'Change other KP number completed');
    } catch (_error) {
      this.loggingService.logError(_xid, 'App.Services.BusOtherKpFilterService.changeOtherKpNumber', _error, null, 'Change other KP number failed');
      throw _error;
    }
  }

  changeClearModalFilter(key: string) {
    const _xid = this.loggingService.generateUUID();
    
    try {
      this.loggingService.logStart(_xid, 'App.Services.BusOtherKpFilterService.changeClearModalFilter', null, 'Change clear modal filter started');
      
      this.messageClearModalFilter.next(key);
      
      this.loggingService.logFinish(_xid, 'App.Services.BusOtherKpFilterService.changeClearModalFilter', null, 'Change clear modal filter completed');
    } catch (_error) {
      this.loggingService.logError(_xid, 'App.Services.BusOtherKpFilterService.changeClearModalFilter', _error, null, 'Change clear modal filter failed');
      throw _error;
    }
  }

  changeClearSearchModalFields(key: string) {
    const _xid = this.loggingService.generateUUID();
    
    try {
      this.loggingService.logStart(_xid, 'App.Services.BusOtherKpFilterService.changeClearSearchModalFields', null, 'Change clear search modal fields started');
      
      this.messageClearSearchModalFields.next(key);
      
      this.loggingService.logFinish(_xid, 'App.Services.BusOtherKpFilterService.changeClearSearchModalFields', null, 'Change clear search modal fields completed');
    } catch (_error) {
      this.loggingService.logError(_xid, 'App.Services.BusOtherKpFilterService.changeClearSearchModalFields', _error, null, 'Change clear search modal fields failed');
      throw _error;
    }
  }

  changeContractBaseOtherKp(contractBaseOtherKp: ContractorBaseAuction) {
    const _xid = this.loggingService.generateUUID();
    
    try {
      this.loggingService.logStart(_xid, 'App.Services.BusOtherKpFilterService.changeContractBaseOtherKp', null, 'Change contract base other KP started');
      
      this.messageContractBaseOtherKp.next(contractBaseOtherKp);
      
      this.loggingService.logFinish(_xid, 'App.Services.BusOtherKpFilterService.changeContractBaseOtherKp', null, 'Change contract base other KP completed');
    } catch (_error) {
      this.loggingService.logError(_xid, 'App.Services.BusOtherKpFilterService.changeContractBaseOtherKp', _error, null, 'Change contract base other KP failed');
      throw _error;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/other-kp/services/bus-other-kp-filter.service.ts